import {
    Stack,
    Checkbox,
    FormControlLabel,
    Typography,
    Collapse,
    Alert,
} from "@mui/material"
import { ReactElement, useContext, useState } from "react"

import { ITEMS_INSTALLER, ITEMS_MANUFACTURER } from "./inviteReview"
import useAcceptInvite from "../../../services/middleware/hooks/account/useAcceptInvite"
import AppButton from "../../buttons/appButton"
import AppLoadingButton from "../../buttons/appLoadingButton"
import CheckMarkList from "../../dataDisplay/lsits/checkMarkList"
import { BUTTON_SPACING } from "../common/config"
import FullScreenTitleContent from "../common/fullScreenTitleContent"
import { AccountSetUpContext } from "../providers/firstLoginProvider"
import { INVITE_REVIEW } from "../screenDispatchers/firstLoginConstants"

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Unreachable code error
// eslint-disable-next-line no-undef
const CONFIG = GLOBAL_CONFIG

/** Are you sure prompt when accepting an invite */
const InviteAreYouSure = (): ReactElement => {
    const { setCurrentScreen, invite } = useContext(AccountSetUpContext)
    const { acceptInvite, isAccepting, error } =
        useAcceptInvite(setCurrentScreen)

    const [termsAccepted, setTermsAccepted] = useState(false)

    return (
        <FullScreenTitleContent
            titlePrimaryColor="Are you sure?"
            titleMain=""
            subtitle={`Are you sure you want to join ${invite?.organisationName}?`}
            content={
                <>
                    <Typography
                        variant="h6"
                        fontWeight={400}
                        color="text.secondary"
                    >
                        As a reminder:
                    </Typography>

                    <CheckMarkList
                        secondary
                        variant="h6"
                        fontWeight={400}
                        items={
                            invite?.organisationType === "installer"
                                ? ITEMS_INSTALLER
                                : ITEMS_MANUFACTURER
                        }
                    />
                </>
            }
            actionContent={
                <Stack width="100%" spacing={BUTTON_SPACING}>
                    <FormControlLabel
                        sx={{ width: "100%" }}
                        control={
                            <Checkbox
                                checked={termsAccepted}
                                disabled={isAccepting}
                                onChange={(event) =>
                                    setTermsAccepted(event.target.checked)
                                }
                            />
                        }
                        label={
                            <Typography>
                                I have read the above and consent to my
                                information being transferred
                            </Typography>
                        }
                    />
                    <Collapse in={!!error}>
                        <Stack width="100%" spacing={BUTTON_SPACING}>
                            <Alert severity="warning">
                                {error?.displayDetail}
                            </Alert>
                            <AppButton
                                fullWidth
                                variant="outlined"
                                color="warning"
                                onClick={() =>
                                    window.open(CONFIG.SN_PORTAL_URL, "_blank")
                                }
                                disabled={isAccepting}
                            >
                                Support Portal
                            </AppButton>
                        </Stack>
                    </Collapse>
                    <AppLoadingButton
                        fullWidth
                        variant="contained"
                        loading={isAccepting}
                        disabled={!termsAccepted || isAccepting}
                        onClick={acceptInvite}
                    >
                        Yes, I am sure
                    </AppLoadingButton>
                    <AppButton
                        fullWidth
                        variant="contained"
                        color="error"
                        disabled={isAccepting}
                        onClick={() => {
                            setCurrentScreen(INVITE_REVIEW)
                        }}
                    >
                        No, go back
                    </AppButton>
                </Stack>
            }
        />
    )
}

export default InviteAreYouSure
